module.exports = __webpack_public_path__ + "static/after-hours-9bf239224b66c4a4e92459e8d6f1a894.mp3";